import { strings as stringManager } from '../../Strings';
export const moduleName = 'eeCompensationCard';
stringManager.load(moduleName, {
    cardTitle: 'Total Compensation',
    description: 'Total Cash Compensation + Company Contributions',
    notApplicable: 'N/A'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
